<template>
  <div class="builder-component-container">
    <BuilderRow v-for="(row, i) in rows" :key="i" :row="row" v-bind="$attrs" />
  </div>
</template>

<script lang="ts" setup>
import BuilderRow, { Row } from '@/components/Builder/BuilderRow.vue'

type Props = {
  rows: Row[]
}

defineProps<Props>()
defineEmits<{
  (event: string): void
}>()

export type { Row }
</script>

<style scoped lang="scss">
.builder-component-container {
  display: block;
}
</style>
